import Cleave from 'cleave.js/react';

const CleaveComponent = ({ classes, ...rest }: any) => {
    return (
        //@ts-ignore
        <Cleave className={classes} options={{creditCard: true}} {...rest}/>
    )
}

export default CleaveComponent;